import React from "react";
import { PopupAnimation } from "@learningblocks/storybook-components";
import osmosis from "./animation/osmosis.json";
import dissolve from "./animation/dissolve_egg.json";
import { useSimulation } from "@learningblocks/simulation-engine";

export default function TimerAnimationModal(props: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { HourPassed } = useSimulation() as {
    HourPassed: number;
  };
  return (
    <PopupAnimation
      key={HourPassed < 24 ? "dissolve" : "osmosis"}
      open={props.isOpen}
      label={""}
      watched={false}
      setWatched={() => true}
      onClose={props.onClose}
      animationData={HourPassed < 24 ? dissolve : osmosis}
      showControls={false}
    />
  );
}
